// eslint-disable-next-line
import React, { useEffect, useRef, useState } from "react";
/* Components */
import Button from "../button/button";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { fetchChatGPT } from "../../services/chat.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useUsageStore from "../../store/useUsageStore";
import useSessionStore from "../../store/useSessionStore";
import useGlobalStore from "../../store/useGlobalStore";
import { getUsage } from "../../services/useCaseUsage.service";
import { FormProvider, useForm, Controller } from "react-hook-form";
import TextInput2 from "../form-elements/TexInput2/TextInput2";
import TextArea2 from "../form-elements/TextArea2/textArea2";
import useUserStore from "../../store/useUser.store";
import { v4 as uuidv4 } from "uuid";
import { MIX_PANEL_EVENTS } from "../../utils/constans";
import useCaseStore from "../../store/useCaseStore";
import ReactSelect from "react-select";
import FileUploader from "../fileUploader/fileUploader";
import Popup from "../popup/popup";

const FormCourseProfile = () => {
  const navigate = useNavigate();
  const { show } = useSnackbarStore();
  const { sendEvent } = useMixPanel();
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // eslint-disable-next-line
  const { gptSuccess, setGPTSuccess, gptLoading, setGPTLoading } =
    useGlobalStore();
  const { setUsage } = useUsageStore();
  const { user } = useSessionStore();
  const {
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const methods = useForm();
  const { handleSubmit, setValue } = methods;
  const sessionIdRef = useRef(null);
  const { lang } = useUserStore();
  const { useCaseList, setContextUseCaseMessages, setContextUserContext, contextForm } = useCaseStore();

  const currentUseCase = useCaseList?.find(
    (e) => e.description === "contexto_real",
  );
  const useCaseId = currentUseCase ? currentUseCase.id : null;

  const questions = [
    {
      field: "clase",
      question: t("formulario_crearContexto_contexto_clase"),
      default: null,
    },
    {
      field: "grado",
      question: t("formulario_crearContexto_contexto_grado"),
      default: null,
    },
    {
      field: "edad",
      question: t("formulario_crearContexto_contexto_edad"),
      default: "Inferir según el grado",
    },
    {
      field: "concepto",
      question: t("formulario_crearContexto_contexto_concepto"),
      default: null,
    },
    {
      field: "consideraciones",
      question: t("formulario_crearContexto_contexto_consideraciones"),
      default: "no aplican",
    },
  ];

  // const storeUsagemutation = useMutation(storeUsage, {
  //   onSuccess: (data) => {
  //     setUsage({
  //       total: data?.total,
  //       limit: data?.limit,
  //       percentage: data?.usagePercentage,
  //     });
  //   },
  //   onError: () => {},
  // });

  const getUsagemutation = useMutation(getUsage, {
    onSuccess: (data) => {
      setUsage({
        total: data?.total,
        limit: data?.limit,
        percentage: data?.usagePercentage,
      });
    },
    onError: () => {},
  });

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      getUsagemutation.mutate(user?.email);
      sendEvent(MIX_PANEL_EVENTS.contextUseCaseResponse);
      setContextUseCaseMessages(res?.messages);
      setGPTLoading(false);
      setGPTSuccess(true);
      navigate(`/design-context?sessionId=${sessionIdRef.current}`);
    },
    onError: (err) => {
      if (err.response.status === 403) {
        navigate("/");
      } else {
        show("Ocurrio un error, vuelve a intentar", "error");
      }
      setGPTLoading(false);
      setGPTSuccess(false);
    },
  });

  const onSubmit = (formData) => {
    const prepareQuestions = questions.map((e) => ({
      ...e,
      value: formData[e.field],
    }));

    const parsedQuestions = prepareQuestions.map(
      (e) => `${e.question}: ${!e.value && e.default ? e.default : e.value}`,
    );

    const content = `Context: \`\`\`${parsedQuestions.join("  ")}\`\`\` `;
    console.log("content ", content);
    sessionIdRef.current = uuidv4();
    const payload = {
      messages: [{ role: "user", content }],
      type: "contexto_real",
      lang,
      session_id: sessionIdRef.current,
      use_case_id: useCaseId,
    };
    setContextUserContext(content);
    setGPTLoading(true);
    sendEvent(MIX_PANEL_EVENTS.contextUseCaseSend);
    mutation.mutate(payload);
  };

  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.contextUseCaseView);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (contextForm.length) {
      contextForm.forEach((element) => {
        setValue(element.field, element.value);
      });
    }
  }, [contextForm, setValue]);

  useEffect(() => {
    return () => {
      setContextUserContext("");
      setGPTSuccess(false);
    };
    // eslint-disable-next-line
  }, []);

  const SelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "rgb(182 182 182 / 0.25)",
      borderColor: "transparent",
      borderRadius: "8px",
      caretColor: "white",
      "&:hover": { borderColor: "transparent" }, // Borde en hover
    }),
    input: (provided) => ({
      ...provided,
      color: "rgb(38, 38, 38)",
      fontWeight: "bold", // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
      color: "black",
      cursor: "pointer",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#FEFEFE", // Color del indicador
      "&:hover": {
        color: "#3FB2E3", // Color del indicador en hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fefefe", // Establece el color del texto de la opción seleccionada a blanco
      fontWeight: "bold",
    }),
    clearIndicator: (styles) => ({
      ...styles,
      color: 'black', // Aquí puedes poner el color que desees
      ':hover': {
        color: 'black', // Color cuando se pasa el ratón por encima (hover)
      },
    }),
  };

  const options = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
  ];


  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleFiles = (files) => {
    // Procesar la lista de archivos seleccionados
    console.log(files);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-row">
            <TextInput2
              label={"Nombre del perfil de clase"}
              name="nombre_perfil"
              placeHolder={"Ej. Curso 801 o Cálculo 1"}
              maxLength={"60"}
              required
            />
            <TextInput2
              label={"Área académica"}
              name="area_academica"
              placeHolder={"Ej. Matemáticas"}
              maxLength={"20"}
              required
            />
            <TextInput2
              label={"Grado o nivel"}
              name="grado"
              placeHolder={"Ej. Quinto o 2do semestre"}
              maxLength={"20"}
              required
            />
          </div>
          <div className="input-row">
            <TextInput2
              label={"Edad de los estudiantes"}
              name="edad"
              placeHolder={"Ej. 18-22"}
              maxLength={"60"}
              required
            />
            <TextInput2
              label={"Número de estudiantes"}
              name="numero_estudiantes"
              placeHolder={"Ej. 32"}
              maxLength={"20"}
              required
            />
            <div className="input-text">
              <label className="input-label">{"Periodo académico"}</label>
              <Controller
                name="periodo_academico"
                control={control}
                rules={{ required: t("campo_requerido") }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    value={options.find(option => option.value === field.value) || null}
                    options={options}
                    placeholder={"Selecciona un periodo"}
                    onChange={(option) => {
                      const newValue = option ? option.value : null;
                      setValue("periodo_academico", newValue);
                      field.onChange(newValue);
                    }}
                    styles={SelectStyles}
                    isMulti={false}
                    maxMenuHeight={100}
                    menuPlacement="bottom"
                  />
                )}
              />
              {errors.periodo_academico && (
                <span className="error">{errors.periodo_academico.message}</span>
              )}
            </div>
          </div>
          <div className="input-row">
            <div className="input-text">
              <label className="input-label">{"Institución"}</label>
              <Controller
                name="institution"
                control={control}
                rules={{ required: t("campo_requerido") }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    value={options.find(option => option.value === field.value) || null}
                    options={options}
                    placeholder={"Selecciona una institución"}
                    onChange={(option) => {
                      const newValue = option ? option.value : null;
                      setValue("institution", newValue);
                      field.onChange(newValue);
                    }}
                    styles={SelectStyles}
                    isMulti={false}
                    maxMenuHeight={100}
                    menuPlacement="bottom"
                  />
                )}
              />
              {errors.institution && (
                <span className="error">{errors.institution.message}</span>
              )}
            </div>
            <div className="input-text">
              <label className="input-label">{"Recursos"}</label>
              <div className="input-row">
                <Button
                  label={"Cargar recursos"}
                  variant="tertiary"
                  customClassName="!py-2"
                  onClick={togglePopup}
                  disabled={gptLoading}
                />
                <span className="text-4 leading-4 text-LightBlue-500 flex h-full items-center justify-center">o</span>
                <Controller
                  name="recursos"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={options.find(option => option.value === field.value) || null}
                      options={options}
                      className="flex-1"
                      placeholder={"Selecciona un recurso"}
                      onChange={(option) => {
                        const newValue = option ? option.value : null;
                        setValue("recursos", newValue);
                        field.onChange(newValue);
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight={100}
                      menuPlacement="bottom"
                    />
                  )}
                />
              </div>
              {errors.resources && (
                <span className="error">{errors.resources.message}</span>
              )}
            </div>
          </div>
          <TextArea2
            label={"Consideraciones para este curso"}
            name="consideraciones"
            placeholder={t(
              "formulario_crearContexto_campo_placeholder_consideraciones",
            )}
            maxLength={"2000"}
          />
          <div className="form-CTA">
            <Button
              label={
                gptLoading ? `${t("creating")} ...` : "Crear perfil"
              }
              variant="primary"
              typeB="submit"
              disabled={gptLoading}
            />
          </div>
        </form>
      </FormProvider>
      <Popup isOpen={isPopupOpen} onClose={togglePopup}>
        <FileUploader onFileSelect={handleFiles}/>
      </Popup>
    </>
  );
};

export default FormCourseProfile;
